import { RoutePermittedRole } from "shared/constants/AppConst";
import RoleData from "./roleData";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const roleMappingConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/roleMapping",
    exact: true,
    element: isModuleAuthorized("Role Mapping") ? <RoleData /> : <Error403 />,
  },
];
